import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_NOTAS_EVALUATIVAS = 'ALL_NOTAS_EVALUATIVAS';
export const LOADING_ALL_NOTAS_EVALUATIVAS = 'LOADING_ALL_NOTAS_EVALUATIVAS';
export const ACTIVO_NOTAS_EVALUATIVAS = 'ACTIVO_NOTAS_EVALUATIVAS';
export const PARAMS_NOTAS_EVALUATIVAS = 'PARAMS_NOTAS_EVALUATIVAS';
export const CALCULADORA_NOTAS_EVALUATIVAS = 'CALCULADORA_NOTAS_EVALUATIVAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  message: null,
  params: {},
  calculadora: {},
};

export const notasEvaluativasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_NOTAS_EVALUATIVAS:
      return {
        ...state,
        all: action.payload,
      };
    case ACTIVO_NOTAS_EVALUATIVAS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_NOTAS_EVALUATIVAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_NOTAS_EVALUATIVAS:
      return {
        ...state,
        params: action.payload,
      };
    case CALCULADORA_NOTAS_EVALUATIVAS:
      return {
        ...state,
        calculadora: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
